import React from 'react';
import PropTypes from 'prop-types';

const ColumnFilter = ({ column }) => {
  const { filterValue, setFilter } = column;
  return (
    <div>
      <input
        className="form-control input-search"
        value={filterValue || ''}
        onChange={(e) => setFilter(e.target.value)}
      />
    </div>
  );
};

ColumnFilter.propTypes = {
  column: PropTypes.object,
};

export default ColumnFilter;
